import { AbstractResource } from './AbstractResource';

export class Users extends AbstractResource {
    async fetch(params = {}) {
        const { data } = await this.http.get(`/user`, { params });
        return data;
    }

    async mails(id) {
        const { data } = await this.http.get(`/user/${id}/mails`);
        return data;
    }

    async remove(id) {
        await this.http.delete(`/user/${id}`);
    }
}
